var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg4Flat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#FB5B5B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2227 20.418V22.668H11.918L11.8242 20.9688L19.1836 9.4375H21.4453L18.9961 13.6328L14.7656 20.418H24.2227ZM22.0898 9.4375V26.5H19.2656V9.4375H22.0898Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4Flat);
export default __webpack_public_path__ + "static/media/4_flat.4892f83f27e6ad81c34ef9173eee0131.svg";
export { ForwardRef as ReactComponent };